<template>
    <div class="field">
        <!-- <label for="label" class="font-bold">Company/Shared</label> -->
        <SelectButton  v-model="isShared" :options="getSharedTypes()" @click="emit('update:modelValue', isShared)" />
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from 'vue';
import { getSharedTypes } from '../constants/index';
import { SharedTypes } from '../enum';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: String,
        default: SharedTypes.COMPANY,
    },
});

const isShared = ref(props.modelValue);

onMounted(() => {
    if (props.modelValue) {
        emit('update:modelValue', props.modelValue);
    }
});
</script>
